// src/components/PublicRoutes.js

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from './features/authSlice';

const PublicRoutes = () => {
    const isAuthenticated = useSelector(selectIsAuthenticated);
    
    return !isAuthenticated ? <Outlet /> : <Navigate to="/home" replace />;
};

export default PublicRoutes;
